// extracted by mini-css-extract-plugin
export default {"noData":"CommonDoc_noData__Y3enu","content":"CommonDoc_content__qCrUL"};